import { render, staticRenderFns } from "./TermoDesentranhamento.vue?vue&type=template&id=e8438148&scoped=true"
import script from "./TermoDesentranhamento.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamento.vue?vue&type=script&lang=js"
import style0 from "./TermoDesentranhamento.vue?vue&type=style&index=0&id=e8438148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8438148",
  null
  
)

export default component.exports